import { useMobile } from '../../hooks/useMobile';
import UsersTab from './UsersTab';

interface Props {
  onClose: () => void;
}

export default function AdminPanel({ onClose }: Props) {
  const isMobile = useMobile();

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 200,
        background: 'rgba(0,0,0,.55)',
        display: 'flex', alignItems: isMobile ? 'flex-end' : 'center',
        justifyContent: 'center',
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{
        background: 'var(--vs1)',
        border: isMobile ? 'none' : '1px solid var(--shell-border)',
        borderRadius: isMobile ? '12px 12px 0 0' : 8,
        width: isMobile ? '100vw' : '90vw',
        maxWidth: isMobile ? undefined : 920,
        height: isMobile ? '92vh' : undefined,
        maxHeight: isMobile ? undefined : '88vh',
        display: 'flex', flexDirection: 'column', overflow: 'hidden',
        boxShadow: '0 24px 80px rgba(0,0,0,.6)',
      }}>

        {/* Header */}
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: isMobile ? '14px 16px 10px' : '14px 20px',
          borderBottom: '1px solid var(--shell-border)', flexShrink: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {/* Shield icon */}
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--red)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            <span style={{ fontSize: '0.92rem', fontWeight: 700, color: 'var(--shell-text)' }}>
              User Management
            </span>
          </div>
          <button
            onClick={onClose}
            style={{
              background: 'none', border: 'none', color: 'var(--shell-xs)',
              fontSize: '1.1rem', cursor: 'pointer', lineHeight: 1,
              padding: '4px 8px', borderRadius: 3,
            }}
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div style={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            <UsersTab />
          </div>
        </div>
      </div>
    </div>
  );
}
